import React from 'react';
import ReactDOM from 'react-dom';
import { render } from 'react-dom';
import { createStore, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import Globals from './globals';

const store = createStore(combineReducers(Globals.states));
 
ReactDOM.render(
	<Provider store={store}>
		<Router>
	    	<App />
	  	</Router>
	</Provider>
	
, document.getElementById('root'));